export function objectDeepMerge(obj1, obj2) {
  const merged = { ...obj1 };

  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (typeof obj2[key] === 'object' && obj2[key] !== null && !Array.isArray(obj2[key])) {
        if (typeof obj1[key] === 'object' && obj1[key] !== null && !Array.isArray(obj1[key])) {
          merged[key] = objectDeepMerge(obj1[key], obj2[key]);
        } else {
          merged[key] = obj2[key];
        }
      } else {
        merged[key] = obj2[key];
      }
    }
  }

  return merged;
}

export function createObjectByChildrenKeys(keys, value) {
      return keys.length === 0 ? value : {[keys.shift()]: createObjectByChildrenKeys(keys, value)}
}

export function getObjectByTextID(array, text_id) {
  return array.find((item) => item.text_id === text_id)
}

export function getIndexByTextID(array, text_id) {
  return array.findIndex((item) => item.text_id === text_id)
}

export function getObjectByID(array, id, defaultVal = undefined) {
  return array.find((item) => item.id === id) || defaultVal
}

export function getIndexByID(array, id) {
  return array.findIndex((item) => item.id === id)
}

export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export function isEmail (str) {
  return /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/.test(str)
}

export function fixZIP (str = '') {
  return str.replace(/\D/g, '').substring(0, 5)
}


export function formatZIP(input) {
  let digits = String(input).replace(/\D/g, ''); // odstraní vše kromě číslic
  if(digits.length !== 5) return input; // pokud není délka 5, vrátí původní vstup
  return digits.slice(0, 3) + ' ' + digits.slice(3);
}


export const LANGUAGES = {
    currentLanguage: "cz",
    languages: ["cz", "en", "sk", "de", "fr"],
    texts:
      {
        cz: "",
        en: "",
        sk: "",
        de: "",
        fr: ""
      }
  }

